/**
 * Default halloween.js configuration.
 */
export const halloweenConfig = {
  /** Enable the seasonal decorations. */
  enabled: true,
  /** Season dates in DD-MM format. */
  season: {
    start: "01-10",
    end: "31-10",
  },
  /** Color used by spiders, threads, webs, and witches. */
  color: "#000000",
  /** Allowed values: "subtle", "normal", or "party". */
  intensity: "normal",
  /** Corner spider webs. Allowed values: "left-top", "right-top", "left-bottom", "right-bottom". */
  corners: ["left-top", "right-bottom"],
  /** Ambient effects. Allowed keys: eyes, witches, spider-drop, tombstones. */
  effects: {
    eyes: true,
    witches: true,
    "spider-drop": true,
    tombstones: true,
  },
};

export const buildHalloweenClasses = (config) => {
  const classes = ["halloween"];

  config.corners.forEach((corner) => {
    classes.push(`halloween-screen-${corner}`);
  });

  Object.entries(config.effects).forEach(([effect, enabled]) => {
    if (enabled) classes.push(`halloween-${effect}`);
  });

  if (config.intensity !== "normal") {
    classes.push(`halloween-intensity-${config.intensity}`);
  }

  return classes;
};

export default halloweenConfig;
